import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount, currency = 'π') {
  return `${currency} ${amount.toLocaleString()}`
}

export function calculateProgress(current, goal) {
  return Math.min((current / goal) * 100, 100)
}

export function formatTimeLeft(days) {
  if (days === 0) return 'Last day'
  if (days === 1) return '1 day left'
  return `${days} days left`
}
